<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

defineProps({
  events: { type: Array, default: () => [] },
});

const { t } = useI18n();
const historyLabels = computed(() => ({
  payment_responsibilities_updated: t(
    'REAL_ESTATE_FINANCE.HISTORY.PAYMENT_RESPONSIBILITIES_UPDATED'
  ),
  status_changed: t('REAL_ESTATE_FINANCE.HISTORY.STATUS_CHANGED'),
  installment_canceled: t('REAL_ESTATE_FINANCE.HISTORY.INSTALLMENT_CANCELED'),
  payment_confirmed: t('REAL_ESTATE_FINANCE.HISTORY.PAYMENT_CONFIRMED'),
  payment_reverted: t('REAL_ESTATE_FINANCE.HISTORY.PAYMENT_REVERTED'),
  boleto_updated: t('REAL_ESTATE_FINANCE.HISTORY.BOLETO_UPDATED'),
  boleto_uploaded: t('REAL_ESTATE_FINANCE.HISTORY.BOLETO_UPLOADED'),
  boleto_deleted: t('REAL_ESTATE_FINANCE.HISTORY.BOLETO_DELETED'),
  split_released: t('REAL_ESTATE_FINANCE.HISTORY.SPLIT_RELEASED'),
  company_transfer_recorded: t(
    'REAL_ESTATE_FINANCE.HISTORY.COMPANY_TRANSFER_RECORDED'
  ),
}));
const eventLabel = event =>
  historyLabels.value[event?.tipo] || t('REAL_ESTATE_FINANCE.HISTORY.UNKNOWN');
</script>

<template>
  <section
    data-testid="finance-installment-history"
    class="rounded-lais border border-lais-border-soft bg-white p-4 shadow-lais-card"
  >
    <h3 class="font-semibold text-lais-text">
      {{ t('REAL_ESTATE_FINANCE.DETAIL.HISTORY') }}
    </h3>
    <p v-if="!events.length" class="mt-3 text-sm text-lais-text-muted">
      {{ t('REAL_ESTATE_FINANCE.DETAIL.NO_HISTORY') }}
    </p>
    <div v-else class="mt-3 divide-y divide-lais-border-soft">
      <article
        v-for="event in events"
        :key="event.id"
        class="py-3 first:pt-0 last:pb-0"
      >
        <p class="font-semibold text-lais-text">{{ eventLabel(event) }}</p>
        <p class="mt-1 text-sm text-lais-text-muted">
          {{ event.ator?.name }}
          {{ t('REAL_ESTATE_FINANCE.DETAIL.SEPARATOR') }}
          {{ event.ocorrido_em }}
        </p>
        <p v-if="event.motivo" class="mt-1 text-sm text-lais-text-body">
          {{ event.motivo }}
        </p>
      </article>
    </div>
  </section>
</template>
